'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryEditController = function () {
  function CategoryEditController(ProductPagesDataProvider, $state, $timeout, Upload, API_URL, APPLICATION_URL) {
    "ngInject";

    (0, _classCallCheck3.default)(this, CategoryEditController);
    if ($state.params.tabId) this.activeTab = $state.params.tabId;else this.activeTab = 1;
    this.type = 1;
    this.page = {};
    this.page.products = [];
    this.Upload = Upload;
    this.ProductPagesDataProvider = ProductPagesDataProvider;
    this.$state = $state;
    this.$timeout = $timeout;
    this.API_URL = API_URL;
    this.APPLICATION_URL = APPLICATION_URL;
    this.errorShow = 0;
    ProductPagesDataProvider.editor();
    this.setProduct();
  }

  (0, _createClass3.default)(CategoryEditController, [{
    key: 'setProduct',
    value: function setProduct() {
      var vm = this;
      vm.ProductPagesDataProvider.getProductPage(vm.$state.params.id, vm.type).then(function (result) {
        vm.page = result;
        vm.products = [];
        vm.page.products = [];
        console.log(result.id);
        if (result.id != undefined) {
          vm.getProducts(vm);
        } else {
          vm.page = {};
          vm.ProductPagesDataProvider.getCategoryById(vm.$state.params.id).then(function (response) {
            vm.page.name = response.name;
            vm.page.slug = response.slug;
            vm.page.category_id = response.id;
            vm.page.sub_category = 0;
            vm.page.type = vm.type;
          });
        }
      });
    }
  }, {
    key: 'getProducts',
    value: function getProducts(vm) {
      vm.setEditorsData();
      vm.ProductPagesDataProvider.getProductPageProducts(vm.$state.params.id, vm.type).then(function (result) {
        vm.products = result;
      });
    }
  }, {
    key: 'changeProductAssigment',
    value: function changeProductAssigment(product) {
      product.__loading = true;
      var vm = this;
      var productData = { id: product.id, assigned: product.assigned, order: product.order_by };
      var index = vm.page.products.findIndex(function (el) {
        return el.id === product.id;
      });
      if (index !== -1) {
        vm.page.products.splice(index, 1);
      }
      vm.page.products.push(productData);
      product.__loading = false;
    }
  }, {
    key: 'setActiveTab',
    value: function setActiveTab(tabToSet) {
      this.activeTab = tabToSet;
      this.getEditorsData();
    }
  }, {
    key: 'changeProductAssigment',
    value: function changeProductAssigment(product) {
      product.__loading = true;
      var vm = this;
      var productData = { id: product.id, assigned: product.assigned, order: product.order_by };
      var index = vm.page.products.findIndex(function (el) {
        return el.id === product.id;
      });
      if (index !== -1) {
        vm.page.products.splice(index, 1);
      }
      vm.page.products.push(productData);
      product.__loading = false;
    }
  }, {
    key: 'onvertToSlug',
    value: function onvertToSlug(text) {
      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
    }
  }, {
    key: 'updateData',
    value: function updateData(productForm, redirect) {
      var vm = this;
      vm.getEditorsData();
      vm.$timeout(function () {
        if (!productForm.$valid) {
          vm.errorShow = 1;
          vm.$timeout(function () {
            vm.errorShow = 0;
          }, 3000);
          return false;
        }
        if (vm.page.name) vm.page.slug = vm.onvertToSlug(vm.page.name);
        if (!vm.page.sub_category) vm.page.sub_category = 0;
        if (!vm.page.alt) vm.page.alt = vm.page.name;
        if (vm.page.img && vm.page.img.type) {
          vm.updateWithImage(vm.page.img, redirect);
        } else {
          vm.ProductPagesDataProvider.updateProductPage(vm.page, vm.type).then(function (result) {
            vm.page = result;
            vm.page.products = [];
            if (redirect == '1') vm.$state.go('app.categoryList');else {
              vm.successShow = 1;
              vm.$timeout(function () {
                vm.successShow = 0;
              }, 3000);
            }
          });
        }
      }, 5);
    }
  }, {
    key: 'updateWithImage',
    value: function updateWithImage(file, redirect) {
      var vm = this;
      file.upload = vm.Upload.upload({
        url: vm.API_URL + '/productPage/saveProductPageImage',
        method: 'POST',
        data: {
          filename: new Date().valueOf() + file.name,
          file: file
        }
      });
      file.upload.then(function (response) {
        var img = vm.page.img;
        var data = vm.page;
        data.img = vm.APPLICATION_URL + response.data;
        vm.ProductPagesDataProvider.updateProductPage(data, vm.type).then(function (result) {
          vm.page = result;
          vm.page.products = [];
          vm.page.img = img;
          if (redirect == '1') vm.$state.go('app.categoryList');else {
            vm.successShow = 1;
            vm.$timeout(function () {
              vm.successShow = 0;
            }, 3000);
          }
        });
      }, function (response) {
        if (response.status > 0) alert(response.status + ': ' + response.data);
      });
    }
  }, {
    key: 'removeProduct',
    value: function removeProduct(product) {
      if (confirm("Are you sure to delete!") !== true) {
        return false;
      }
      product.__loading = true;
      var vm = this;
      var id = product.id;
      var apid = product.admin_product_id;
      vm.ProductPagesDataProvider.removeProduct(id, apid).then(function (res) {
        vm.ProductPagesDataProvider.getProductPageProducts(vm.$state.params.id, vm.type).then(function (result) {
          vm.products = result;
          product.__loading = false;
        });
      });
    }
  }, {
    key: 'getEditorsData',
    value: function getEditorsData() {
      this.page.short_text = tinyMCE.get('short_text').getContent();
      this.page.template_text = tinyMCE.get('template_text').getContent();
      this.page.long_text = tinyMCE.get('long_text').getContent();
      this.page.meta_data = tinyMCE.get('meta_data').getContent();
    }
  }, {
    key: 'setEditorsData',
    value: function setEditorsData() {
      if (this.page.short_text != undefined) tinyMCE.get('short_text').setContent(this.page.short_text);
      if (this.page.template_text != undefined) tinyMCE.get('template_text').setContent(this.page.template_text);
      if (this.page.long_text != undefined) tinyMCE.get('long_text').setContent(this.page.long_text);
      if (this.page.meta_data != undefined) tinyMCE.get('meta_data').setContent(this.page.meta_data);
    }
  }]);
  return CategoryEditController;
}();

// WEBPACK FOOTER //


exports.default = CategoryEditController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/product-page/components/category_edit/controller.js
 **/